module.exports = __webpack_public_path__ + "static/media/life-ring.be9a8bbd.svg";